if (!customElements.get('ls-quick-add')) {
 customElements.define('ls-quick-add', class extends HTMLElement {
  connectedCallback() {
   this.dialog = this.querySelector('dialog');
   this.content = this.querySelector('[data-quick-content]');
   this.loading = this.querySelector('.ls-quick-loading');
   this.error = this.querySelector('.ls-quick-error');
   this.section = document;
   this.onOpen = event => {
    const link = event.target.closest('[data-ls-quick-open]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault();
    this.open(link);
   };
   this.section?.addEventListener('click', this.onOpen);
   this.querySelector('[data-quick-close]').addEventListener('click', () => this.dialog.close());
   this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
   this.dialog.addEventListener('close', () => {
    this.controller?.abort();
    this.variantController?.abort();
    document.documentElement.classList.remove('ls-quick-open');
    this.opener?.focus({ preventScroll: true });
   });
   this.content.addEventListener('click', event => {
    const mode = event.target.closest('[data-quick-mode]');
    const piece = event.target.closest('[data-quick-piece-value]');
    const step = event.target.closest('[data-quick-step]');
    if (mode) { this.setModularMode(mode.dataset.quickMode); return; }
    if (piece) { this.setModularValue(piece.dataset.quickPieceValue); return; }
    if (step) {
     const input = this.content.querySelector('[name="quantity"]');
     if (step.dataset.quickStep === 'plus') input.stepUp(); else input.stepDown();
     this.renderPrice();
     return;
    }
    const toggle = event.target.closest('.ls-quick-fabric-toggle');
    const option = event.target.closest('[data-quick-fabric-value]');
    if (toggle) this.toggleFabrics(toggle.closest('.ls-quick-fabric'));
    if (option) {
     const field = option.closest('.ls-quick-fabric');
     field.querySelector('select').value = option.dataset.quickFabricValue;
     this.update();
     this.toggleFabrics(field, false);
     field.querySelector('.ls-quick-fabric-toggle').focus();
    }
   });
   this.content.addEventListener('keydown', event => {
    const field = event.target.closest('.ls-quick-fabric');
    if (!field) return;
    const options = [...field.querySelectorAll('[role="option"]')];
    if (event.key === 'Escape' && !field.querySelector('[role="listbox"]').hidden) {
     event.preventDefault(); event.stopPropagation(); this.toggleFabrics(field, false); field.querySelector('[role="combobox"]').focus(); return;
    }
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
     event.preventDefault();
     const current = options.indexOf(event.target);
     this.toggleFabrics(field, true, false);
     const index = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : current < 0 ? Math.max(0, options.findIndex(item => item.getAttribute('aria-selected') === 'true')) : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
     options[index]?.focus();
    }
   });
   this.content.addEventListener('focusout', event => {
    const field = event.target.closest('.ls-quick-fabric');
    if (field && event.relatedTarget && !field.contains(event.relatedTarget)) this.toggleFabrics(field, false);
   });
   this.content.addEventListener('change', event => {
    if (event.target.matches('[data-quick-composition]')) this.setModularValue(event.target.value);
    if (event.target.matches('[data-quick-option]')) this.update();
    if (event.target.matches('[name="quantity"]')) this.renderPrice();
   });
   this.content.addEventListener('input', event => {
    if (event.target.matches('[name="quantity"]')) this.renderPrice();
   });
   this.content.addEventListener('submit', event => {
    const product = event.target.closest('[data-quick-modular]');
    if (product && (!this.currentVariant?.available || !product.querySelector('[name="quantity"]').checkValidity() || String(this.currentVariant.id) !== product.querySelector('[name="id"]').value)) {
     event.preventDefault();
     event.stopImmediatePropagation();
    }
   }, true);
   if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (this.dialog.open && event.source === 'product-form' && String(event.productVariantId) === this.content.querySelector('[name="id"]')?.value) this.dialog.close();
   });
  }
  disconnectedCallback() {
   this.section?.removeEventListener('click', this.onOpen);
   this.unsubscribe?.();
   this.controller?.abort();
   this.variantController?.abort();
   this.modular = null;
   this.currentVariant = null;
   document.documentElement.classList.remove('ls-quick-open');
  }
  async open(link) {
   this.opener = link;
   this.variantController?.abort();
   this.modular = null;
   this.currentVariant = null;
   this.content.replaceChildren();
   this.error.hidden = true;
   this.loading.hidden = false;
   this.querySelector('[data-quick-fallback]').href = link.href;
   document.documentElement.classList.add('ls-quick-open');
   this.dialog.showModal();
   this.controller?.abort();
   const controller = new AbortController();
   this.controller = controller;
   try {
    const url = new URL(link.href);
    url.searchParams.set('section_id', 'ls-2027-quick-product');
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) throw new Error('Product unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const product = doc.querySelector('[data-quick-product]');
    if (!product) throw new Error('Product unavailable');
    const variant = JSON.parse(product.querySelector('[data-quick-variant]').textContent);
    if (controller.signal.aborted) return;
    this.content.append(document.importNode(product, true));
    this.initModular();
    this.syncFabrics();
    this.renderVariant(variant);
   } catch (error) {
    if (error.name !== 'AbortError') this.error.hidden = false;
   } finally { if (this.controller === controller) this.loading.hidden = true; }
  }
  initModular() {
   const product = this.content.querySelector('[data-quick-modular]');
   if (!product) return;
   const native = product.querySelector('[data-quick-modular-native]');
   const mode = native.selectedOptions[0]?.dataset.quickKind || 'composition';
   this.modular = { mode, values: { [mode]: native.value }, quantities: { composition: 1, extra: 1 } };
   this.syncModular();
  }
  setModularMode(mode) {
   const product = this.content.querySelector('[data-quick-modular]');
   if (!product || !this.modular || this.modular.mode === mode) return;
   const native = product.querySelector('[data-quick-modular-native]');
   const input = product.querySelector('[name="quantity"]');
   this.modular.values[this.modular.mode] = native.value;
   if (input.checkValidity()) this.modular.quantities[this.modular.mode] = Number(input.value);
   const candidates = [...native.options].filter(option => option.dataset.quickKind === mode);
   const next = candidates.find(option => option.value === this.modular.values[mode]) || candidates.find(option => option.dataset.available === 'true') || candidates[0];
   if (!next) return;
   this.modular.mode = mode;
   input.value = this.modular.quantities[mode];
   this.setModularValue(next.value);
  }
  setModularValue(value) {
   const native = this.content.querySelector('[data-quick-modular-native]');
   if (!native || !this.modular) return;
   native.value = value;
   this.modular.values[this.modular.mode] = value;
   this.syncModular();
   this.update();
  }
  syncModular() {
   const product = this.content.querySelector('[data-quick-modular]');
   if (!product || !this.modular) return;
   const native = product.querySelector('[data-quick-modular-native]');
   const pieces = this.modular.mode === 'extra';
   product.querySelectorAll('[data-quick-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.quickMode === this.modular.mode)));
   product.querySelector('[data-quick-composition-field]').hidden = pieces;
   product.querySelector('[data-quick-pieces]').hidden = !pieces;
   if (!pieces) product.querySelector('[data-quick-composition]').value = native.value;
   product.querySelectorAll('[data-quick-piece-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.quickPieceValue === native.value)));
   const piece = product.querySelector('[data-quick-piece-value][aria-pressed="true"]');
   const details = product.querySelector('[data-quick-piece-details]');
   if (details) details.textContent = pieces && piece
    ? [...piece.querySelectorAll('.ls-quick-piece-size, .ls-quick-piece-price')].map(item => item.textContent.trim()).join(' · ')
    : '';
  }
  toggleFabrics(field, open, focus = true) {
   const list = field.querySelector('[role="listbox"]');
   const expanded = open ?? list.hidden;
   list.hidden = !expanded;
   field.querySelector('[role="combobox"]').setAttribute('aria-expanded', String(expanded));
   if (expanded && focus) (list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]'))?.focus();
  }
  syncFabrics() {
   const product = this.content.querySelector('[data-quick-product]');
   product.querySelectorAll('.ls-quick-fabric').forEach(field => {
    const value = field.querySelector('select').value;
    field.querySelectorAll('[data-quick-fabric-value]').forEach(option => {
     const chosen = option.dataset.quickFabricValue === value;
     option.setAttribute('aria-selected', String(chosen));
     if (chosen) {
      field.querySelector('[data-quick-fabric-name]').textContent = option.querySelector('[data-fabric-label]').textContent;
      field.querySelector('[data-quick-fabric-swatch]').style.cssText = option.querySelector('.ls-quick-swatch').style.cssText;
     }
    });
   });
  }
  async update() {
   const product = this.content.querySelector('[data-quick-product]');
   if (!product) return;
   this.currentVariant = null;
   this.syncFabrics();
   this.variantController?.abort();
   const controller = new AbortController();
   this.variantController = controller;
   const button = product.querySelector('[type="submit"]');
   button.disabled = true;
   button.setAttribute('aria-busy', 'true');
   button.querySelector('span').textContent = product.dataset.loadingLabel;
   product.querySelector('[name="id"]').value = '';
   product.querySelector('[data-quick-price]').textContent = '…';
   product.querySelector('[data-quick-compare]').hidden = true;
   const choice = product.querySelector('[data-quick-choice]');
   if (choice) choice.textContent = product.dataset.resolvingLabel;
   product.querySelectorAll('[data-quick-piece-price]').forEach(price => { price.textContent = '…'; });
   const pieceDetails = product.querySelector('[data-quick-piece-details]');
   if (pieceDetails) pieceDetails.textContent = '…';
   this.error.hidden = true;
   try {
    const url = new URL(product.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', 'ls-2027-quick-product');
    url.searchParams.set('option_values', [...product.querySelectorAll('[data-quick-option]')].map(select => select.selectedOptions[0].dataset.optionValueId).join(','));
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) throw new Error('Product unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-quick-variant]');
    if (!data) throw new Error('Product unavailable');
    if (controller.signal.aborted || !product.isConnected) return;
    const freshPicker = doc.querySelector('[data-quick-modular-picker]');
    const picker = product.querySelector('[data-quick-modular-picker]');
    if (picker && freshPicker) {
     const focused = picker.contains(document.activeElement) ? document.activeElement : null;
     const focusedPiece = focused?.dataset.quickPieceValue;
     const focusedComposition = focused?.matches('[data-quick-composition]');
     const requested = product.querySelector('[data-quick-modular-native]').value;
     picker.replaceWith(document.importNode(freshPicker, true));
     product.querySelector('[data-quick-modular-native]').value = requested;
     this.syncModular();
     if (focusedPiece) [...product.querySelectorAll('[data-quick-piece-value]')].find(item => item.dataset.quickPieceValue === focusedPiece)?.focus({ preventScroll: true });
     if (focusedComposition) product.querySelector('[data-quick-composition]').focus({ preventScroll: true });
    }
    product.querySelectorAll('[data-quick-option]').forEach((select, index) => {
     const fresh = doc.querySelectorAll('[data-quick-option]')[index];
     if (!fresh) return;
     [...select.options].forEach(option => {
      const match = [...fresh.options].find(item => item.value === option.value);
      if (match) option.textContent = match.textContent;
     });
    });
    const summary = product.querySelector('[data-quick-summary]');
    const nextSummary = doc.querySelector('[data-quick-summary]');
    if (summary && nextSummary) summary.replaceChildren(...nextSummary.childNodes);
    button.removeAttribute('aria-busy');
    this.renderVariant(JSON.parse(data.textContent));
   } catch (error) {
    if (error.name !== 'AbortError' && product.isConnected) {
     button.removeAttribute('aria-busy');
     this.renderVariant(null);
     this.error.hidden = false;
    }
   } finally {
    if (this.variantController === controller) button.removeAttribute('aria-busy');
   }
  }
  renderVariant(variant) {
   const product = this.content.querySelector('[data-quick-product]');
   if (!product) return;
   const selects = [...product.querySelectorAll('[data-quick-option]')];
   if (this.modular && variant && !selects.every((select, index) => select.value === variant.options[index])) variant = null;
   this.currentVariant = variant;
   const form = product.querySelector('product-form');
   const button = form.querySelector('[type="submit"]');
   form.querySelector('[name="id"]').value = variant?.id || '';
   button.disabled = !variant?.available;
   button.removeAttribute('aria-disabled');
   button.querySelector('span').textContent = !variant ? product.dataset.unavailableLabel : variant.available ? product.dataset.addLabel : product.dataset.soldLabel;
   form.handleErrorMessage?.();
   form.error = false;
   if (variant?.quantityRule) {
    const input = product.querySelector('[name="quantity"]');
    const rule = variant.quantityRule;
    input.min = rule.min;
    input.step = rule.increment;
    if (rule.max != null) input.max = rule.max; else input.removeAttribute('max');
   }
   this.renderPrice();
   const details = new URL(product.dataset.productUrl, location.origin);
   if (variant) details.searchParams.set('variant', variant.id);
   product.querySelector('[data-quick-details]').href = details.href;
   const photo = product.querySelector('.ls-quick-photo');
   if (photo && variant?.image) { photo.removeAttribute('srcset'); photo.src = variant.image; photo.alt = [product.querySelector('h3').textContent, ...selects.map(select => select.selectedOptions[0].textContent)].join(' · '); }
  }
  renderPrice() {
   const product = this.content.querySelector('[data-quick-product]');
   const variant = this.currentVariant;
   if (!product) return;
   const input = product.querySelector('[name="quantity"]');
   const quantity = Number(input.value);
   const valid = Number.isInteger(quantity) && input.checkValidity();
   product.querySelector('[type="submit"]').disabled = !variant?.available || !valid;
   const format = amount => new Intl.NumberFormat(product.dataset.locale, { style: 'currency', currency: product.dataset.currency || 'EUR' }).format(amount * quantity / 100);
   product.querySelector('[data-quick-price]').textContent = variant && valid ? (quantity === 1 ? variant.price : format(variant.amount)) : '—';
   const compare = product.querySelector('[data-quick-compare]');
   compare.hidden = !variant?.compare || !valid;
   compare.textContent = variant?.compare && valid ? (quantity === 1 ? variant.compare : format(variant.compareAmount)) : '';
   if (this.modular) {
    if (valid) this.modular.quantities[this.modular.mode] = quantity;
    const selected = product.querySelector('[data-quick-modular-native]').selectedOptions[0];
    const piece = [...product.querySelectorAll('[data-quick-piece-value]')].find(item => item.dataset.quickPieceValue === selected?.value);
    const label = this.modular.mode === 'extra' ? piece?.dataset.pieceName : selected?.textContent.trim();
    product.querySelector('[data-quick-choice]').textContent = variant ? `${valid ? quantity : '—'} × ${label || ''}` : (this.variantController && !this.variantController.signal.aborted && product.querySelector('[type="submit"]').hasAttribute('aria-busy') ? product.dataset.resolvingLabel : product.dataset.unavailableLabel);
    if (variant?.available) product.querySelector('[type="submit"] span').textContent = this.modular.mode === 'extra' && piece ? (quantity === 1 ? piece.dataset.addOne : piece.dataset.addMany.replace('[count]', valid ? quantity : '—')) : product.dataset.addLabel;
    const minus = product.querySelector('[data-quick-step="minus"]');
    const plus = product.querySelector('[data-quick-step="plus"]');
    minus.disabled = valid && quantity <= Number(input.min);
    plus.disabled = valid && input.max !== '' && quantity >= Number(input.max);
   }
  }
 });
}


